import React from 'react';
import { AnimatedBackground } from './AnimatedBackground';

interface PageLayoutProps {
  children: React.ReactNode;
  className?: string;
}

export const PageLayout: React.FC<PageLayoutProps> = ({ children, className = '' }) => {
  return (
    <div className="relative min-h-screen">
      <AnimatedBackground />
      
      {/* Content */}
      <div className={`relative z-10 container mx-auto px-4 py-12 ${className}`}>
        {children}
      </div>

      {/* Global Animations */}
      <style>
        {`
          @keyframes moveGrid {
            0% {
              transform: translate(0, 0);
            }
            100% {
              transform: translate(4rem, 4rem);
            }
          }

          @keyframes float {
            0%, 100% {
              transform: translate(0, 0);
            }
            25% {
              transform: translate(50px, -50px);
            }
            50% {
              transform: translate(100px, 0);
            }
            75% {
              transform: translate(50px, 50px);
            }
          }
        `}
      </style>
    </div>
  );
}; 